/**
 * Single source of truth for the Data Subject Matching Rules "Behavior" control.
 * Each behaviour is a named combination of the two wire booleans allowBlanks/mustBeBlank.
 * These helpers only translate between the UI's single dropdown value and the two
 * booleans the MatchingRules API already expects — the wire format is unchanged.
 */

export const BEHAVIOR_OPTIONS = [
	{ value: 'exact', text: 'Values must be identical in submission and CMP', allowBlanks: false, mustBeBlank: false },
	{ value: 'matchOnNull', text: 'Values must be identical and can be NULL', allowBlanks: true, mustBeBlank: false },
	{ value: 'mustBeNull', text: 'Values must be NULL in submission and CMP', allowBlanks: false, mustBeBlank: true },
	{ value: 'exception', text: 'Prevent match if field is populated in submission and CMP', allowBlanks: true, mustBeBlank: true }
]

// Pre-mapped {value, text} list for direct use as Dropdown `items` — the options
// never change, so there's no need to recompute this per component instance.
export const BEHAVIOR_ITEMS = BEHAVIOR_OPTIONS.map(o => ({ value: o.value, text: o.text }))

// Exact — also the safe default, matching the both-false default for new rules.
const DEFAULT_OPTION = BEHAVIOR_OPTIONS[0]

function optionFromFlags (allowBlanks, mustBeBlank) {
	const a = Boolean(allowBlanks)
	const m = Boolean(mustBeBlank)
	return BEHAVIOR_OPTIONS.find(o => o.allowBlanks === a && o.mustBeBlank === m) || DEFAULT_OPTION
}

export function behaviorValueFromFlags (allowBlanks, mustBeBlank) {
	return optionFromFlags(allowBlanks, mustBeBlank).value
}

export function behaviorTextFromFlags (allowBlanks, mustBeBlank) {
	return optionFromFlags(allowBlanks, mustBeBlank).text
}

export function flagsFromBehaviorValue (value) {
	const option = BEHAVIOR_OPTIONS.find(o => o.value === value) || DEFAULT_OPTION
	return { allowBlanks: option.allowBlanks, mustBeBlank: option.mustBeBlank }
}
